import { useContext } from 'react';
import { ConversationContext } from '../context/ConversationContext';

/**
 * Custom hook to access ConversationContext
 * 
 * Must be used inside ConversationProvider
 * 
 * @returns {Object} Conversation context value
 * 
 * @throws {Error} If used outside ConversationProvider
 * 
 * @example
 * function MyComponent() {
 *   const { activeConversation, activeMessages } = useConversation();
 *   return <div>{activeConversation?.title}</div>;
 * }
 */
export const useConversation = () => {
  const context = useContext(ConversationContext);

  if (!context) {
    throw new Error(
      'useConversation must be used within ConversationProvider. ' +
      'Wrap your app with <ConversationProvider> at the top level.'
    );
  }

  return context;
};

export default useConversation;
